export class OfflineError extends Error {
    constructor() {
        super("You are currently offline and cannot access certain functions. Please check your internet connection and try again.");
        this.name = OfflineError.name;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2ZmbGluZS1lcnJvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vZmZsaW5lLWVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sT0FBTyxZQUFhLFNBQVEsS0FBSztJQUNyQztRQUNFLEtBQUssQ0FDSCxxSEFBcUgsQ0FDdEgsQ0FBQztRQUNGLElBQUksQ0FBQyxJQUFJLEdBQUcsWUFBWSxDQUFDLElBQUksQ0FBQztJQUNoQyxDQUFDO0NBQ0YifQ==